import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import CityHero from '../../components/feature/CityHero';
import Services from '../home/components/Services';
import Testimonials from '../home/components/Testimonials';
import Contact from '../home/components/Contact';
import FAQ from '../home/components/FAQ';

export default function ReparationFenetreSaintGenisLaval() {
  useEffect(() => {
    document.title = 'Saint-Genis-Laval Réparation Fenêtres Fenêtres Lyon | Expert Fenêtres';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Saint-Genis-Laval Réparation Fenêtres Fenêtres Lyon - Service professionnel de réparation de fenêtres à Saint-Genis-Laval. Intervention rapide, devis gratuit. Spécialiste fenêtres PVC, alu, bois. Appelez-nous !');
    }
  }, []);

  return (
    <>
      <div className="min-h-screen bg-white">
        <Navbar />
        <CityHero 
          cityName="Saint-Genis-Laval"
          imageSeq="saint-genis-laval-hero-018"
        />
        <Services />
        <Testimonials />
        <Contact />
        <FAQ />
        <Footer />
      </div>
    </>
  );
}
